import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth';

export const permissionsGuard: CanActivateFn = (route) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    const permissions = route.data['permissions'] || [];

    if (authService.hasPermissions(permissions)) return true;

    router.navigate(['/unauthorized']);
    return false;
};
